/**
 * Texte zur Gruppierung der Korrespondenz – gemeinsam für „Mein Profil ›
 * Korrespondenz“ und den Umschalter direkt in der Korrespondenz
 * (Kundenfeedback 18.10.2026, IV: „gebündelt“ besser erklären und den
 * Nachteil offen nennen).
 */
import type { CorrespondenceGrouping } from '@/services/userSettings'
import { gt } from '@/i18n/gt'

export interface GroupingOption {
  value: CorrespondenceGrouping
  /** Kurzlabel für den Umschalter. */
  short: string
  title: string
  description: string
  /** Offen genannter Nachteil (leer, wenn keiner). */
  drawback: string
  recommended: boolean
}

/** Profilbereich, in dem die Gruppierung dauerhaft festgelegt wird. */
export const PROFILE_GROUPING_LINK = {
  path: '/benutzereinstellungen',
  query: { abschnitt: 'korrespondenz' },
} as const

export function groupingOptions (): GroupingOption[] {
  return [
    {
      value: 'participant',
      short: gt('Einzeln'),
      title: gt('Je Beteiligtem einzeln'),
      description: gt('Jeder Beteiligte – z. B. Werkstatt, Sachverständiger, Versicherung oder Kunde – hat genau einen Verlauf. Eine E-Mail an mehrere Empfänger erscheint bei jedem von ihnen. So finden Sie alles zu einer Person oder Firma an einer Stelle.'),
      drawback: '',
      recommended: true,
    },
    {
      value: 'group',
      short: gt('Gruppen'),
      title: gt('Nach Absender- und Empfängergruppen gebündelt'),
      description: gt('Eine Gruppe ist eine bestimmte Kombination von Beteiligten, ähnlich einem Gruppenchat. Jede Kombination bildet eine eigene Unterhaltung – auch dann, wenn jemand nur in CC oder BCC steht. Beispiel: Eine E-Mail an Versicherung und Werkstatt und eine weitere an Versicherung, Werkstatt und den Kunden in CC landen in zwei verschiedenen Gruppen.'),
      drawback: gt('Nachteil: Weil Sie Beteiligte oft in wechselnden Konstellationen anschreiben, entstehen schnell sehr viele Gruppen – darunter leidet die Übersicht. Deshalb empfehlen wir „Je Beteiligtem einzeln“.'),
      recommended: false,
    },
  ]
}

export function groupingOption (value: CorrespondenceGrouping): GroupingOption {
  const options = groupingOptions()
  return options.find(o => o.value === value) ?? options[0]!
}
